import * as React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useDispatch } from 'react-redux'
import GenericButton from '../../../../../../components/GenericButton'
import { ButtonSize, ButtonType } from '../../../../../../components/GenericButton/styles'
import { deleteQuestionFromSection, type ISurveySection, moveQuestionDown, moveQuestionUp } from '../../../../../../store/slices/SurveyTemplateSlice'
import GenericModal from '../../../../../../components/GenericModal'
import { Typography } from '@mui/material'
import { type Question } from '../../../../types'
import { updateElementBorderColor } from '../../../../helpers'
interface PreparedQuestionCardDropDownMenuProps {
  questionIndex: number
  sectionIndex: number
  totalQuestionInSection: number
  question: Question
  section: ISurveySection
}

const PreparedQuestionCardDropDownMenu: React.FC<PreparedQuestionCardDropDownMenuProps> = ({ questionIndex, sectionIndex, totalQuestionInSection, question, section }): JSX.Element => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [isConfirmModal, setIsConfirmModal] = React.useState<boolean>(false)

  const closeConfirmModal = (): void => {
    setIsConfirmModal(false)
  }

  const dispatch = useDispatch()

  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleDeleteClick = (): void => {
    if (question?.branchingFilters && question?.branchingFilters.length > 0) {
      setIsConfirmModal(true)
      return
    }
    dispatch(deleteQuestionFromSection({ surveySectionId: section.surveySectionId, questionIndex }))
    setAnchorEl(null)
  }

  const moveUp = (): void => {
    dispatch(moveQuestionUp({ surveySectionId: section.surveySectionId, questionIndex }))
    updateElementBorderColor(question?.itemId ?? '', '')

    handleClose()
  }
  const moveDown = (): void => {
    dispatch(moveQuestionDown({ surveySectionId: section.surveySectionId, questionIndex }))
    updateElementBorderColor(question?.itemId ?? '', '')

    handleClose()
  }

  return (
    <>
      <GenericButton
        buttonType={ButtonType.Ghost}
        buttonSize={ButtonSize.Small}
        icon={<MoreVertIcon />}
        onClick={handleClick}
        style={{
          background: 'transparent'
        }} />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
      >
        <MenuItem disabled={questionIndex === 0} onClick={moveUp}>Move Up</MenuItem>
        <MenuItem disabled={totalQuestionInSection - 1 === questionIndex} onClick={moveDown}>Move Down</MenuItem>
        <MenuItem disabled={totalQuestionInSection === 1} onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>

      <GenericModal maxWidth='sm' title={'Branch Section'} isOpen={isConfirmModal} onClose={closeConfirmModal} hideConfirmButton>
        <Typography>This Question contains a Branch section. You cannot delete this section
        </Typography>
      </GenericModal>
    </>
  )
}

export default PreparedQuestionCardDropDownMenu
